import React from "react";

import { cx } from "@/lib/tailwind-utils";

interface RainforestSkeletonProps {
  /** Container padding (affects overall spacing) */
  padding?: "sm" | "md" | "lg";
  /** Additional className for the container */
  className?: string;
  /** Custom background color */
  backgroundColor?: string;
}

const RainforestSkeleton: React.FC<RainforestSkeletonProps> = ({
  padding = "md",
  className,
  backgroundColor = "",
}) => {
  const paddingClasses = {
    sm: "p-2",
    md: "p-4",
    lg: "p-6",
  };

  return (
    <div
      className={cx(
        "w-full space-y-4",
        backgroundColor,
        paddingClasses[padding],
        className,
      )}
    >
      {/* Card number field */}
      <div className="space-y-2">
        <div className="h-4 w-24 animate-pulse rounded bg-muted"></div>
        <div className="h-10 w-full animate-pulse rounded bg-muted"></div>
      </div>

      {/* Expiry and CVC fields */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <div className="h-4 w-16 animate-pulse rounded bg-muted"></div>
          <div className="h-10 w-full animate-pulse rounded bg-muted"></div>
        </div>
        <div className="space-y-2">
          <div className="h-4 w-12 animate-pulse rounded bg-muted"></div>
          <div className="h-10 w-full animate-pulse rounded bg-muted"></div>
        </div>
      </div>
    </div>
  );
};

export default RainforestSkeleton;
